import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, NgZone, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { timer } from 'rxjs';

import {
  AuthService,
  CustomIconsService,
  ScanProgressService,
} from './core/services';
import { IScanState } from './core/interfaces';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,

})
export class AppComponent implements OnInit, AfterViewInit {
  public scanState: IScanState;
  public isCollapsed = false;
  public showScanProgressBanner = true;
  public partner: {
    name: string;
    title: string
    useTitle: number;
    loginLogo: string;
    headerLogo: string;
    favicon: string;
  } = {
      name: 'test2',
      title: '',
      useTitle: 0,
      loginLogo: '/assets/img/logo.svg',
      headerLogo: '/assets/img/logo.svg',
      favicon: '',
    };

  public domainVerified = false;

  protected sidebarHeight = 'auto';

  private _document = inject(DOCUMENT);
  private zone = inject(NgZone);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  @ViewChild('menu') protected menu: ElementRef;

  constructor(
    private authService: AuthService,
    private scanProgressService: ScanProgressService,
    private titleService: Title,
    private cdRef: ChangeDetectorRef,
    private customIconsService: CustomIconsService,
  ) {
    this.customIconsService.onCreateCustomIconsHandler();
    this.router.events.subscribe((ev) => {
      if (ev instanceof ActivationEnd) {
        this.showScanProgressBanner = !this.route.snapshot.firstChild?.data?.hideScanProgress;
      }
    });

    this.scanProgressService.scanState$
      .subscribe((res) => {
        this.scanState = res;
      });
  }

  public ngOnInit() {
    // Deferred: this request only sets the favicon and the document title, so it can wait.
    // The API host serves HTTP/1.1, where the browser keeps at most 6 connections open —
    // every request sent during the initial burst pushes the dashboard tables into the
    // next connection round. Login/reset/activate pages fetch their own copy for branding.
    timer(2500).subscribe(() => this.getPartnerPublicInfo());

    const isAuthenticated = this.authService.isAuthenticated();
    const currentPath = window.location.pathname;

    if (isAuthenticated && currentPath === '/') {
      this.router.navigate(['/ssp-dsp-dashboard']);
    }


    if (!isAuthenticated && currentPath === '/') {
      void this.router.navigate(['/login']);
    }

    // A focused <input type="number"> treats the mouse wheel as increment/decrement, so
    // scrolling the page with the cursor over one silently edits its value. Blur it instead —
    // the page still scrolls, the value stays. Bound on the document in the capture phase so
    // inputs rendered in cdk overlays (modals, drawers) are covered as well.
    this.zone.runOutsideAngular(() => {
      this._document.addEventListener('wheel', ({ target }) => {
        if (target instanceof HTMLInputElement && target.type === 'number' && target === this._document.activeElement) {
          target.blur();
        }
      }, { capture: true });
    });
  }

  public ngAfterViewInit() {
    let loader = this._document.getElementById('loader');
    if (loader) {
      loader.style.display = 'none';
    }

    this.cdRef.detectChanges();
  }

  private capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  private getPartnerPublicInfo(): void {
    this.authService.getPartnerPublicInfo()
      .subscribe({
        next: (resp) => {
          this.domainVerified = true;
          this.partner = resp.data;
          if (this.partner.favicon) {
            const faviconElement = this._document.getElementById('appFavicon');
            if (faviconElement) {
              faviconElement.setAttribute('href', this.partner.favicon);
            }
          }

          const title = this.partner.useTitle ? this.partner.title : this.capitalize(this.partner.name);
          this.titleService.setTitle(title + ' Ad Exchange');
        },
        error: (err) => {
          this.domainVerified = false;
          // Additional error handling logic if necessary
          console.error('Error fetching partner public info:', err);
        },
      });
  }

}
